import type { Roles } from "@hooks/useUserConfiguration";

export function isSyncSettingsEnabled({
  roles,
  features,
  isLocal,
  isDemo,
}: {
  roles: Roles;
  features: string[];
  isLocal: boolean;
  isDemo: boolean;
}): boolean {
  if (!roles.narmi) return false;
  return isLocal || isDemo || features.includes("import_export_settings");
}
